
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypePsvFilled as ObiVesselTypePsvFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-psv-filled.js';
 
 
 

 
 export const ObiVesselTypePsvFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-psv-filled',
   elementClass: ObiVesselTypePsvFilledElement,
   events: {
     
   }
  });
 
 